import { ACTIVE_PAGE} from '../constants/constants';
import { fetchSuccess} from '../actions/actions';

export const ActivatePage = (activePage) => dispatch =>
{   
    dispatch(fetchSuccess(activePage, ACTIVE_PAGE));     
}

